/* eslint-disable jsx-a11y/anchor-is-valid,react/destructuring-assignment */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export class BecomeAdminButton extends PureComponent {
  static propTypes = {
    becomeAdmin: PropTypes.func.isRequired,
  };

  render() {
    return (
      <div className="section">
        <ul className="class-list">
          <li key="separator" className="separator" />
          <li key="button" className="item">
            <a href="#" onClick={this.props.becomeAdmin}>
              Become course admin
            </a>
          </li>
        </ul>
      </div>
    );
  }
}
